import { useUserInfo } from "context/user";
import Agency from "pages/Agency";
import Location from "pages/Location";
import Login from "pages/Authentication/Login";
import Register from "pages/Authentication/Register";
import Redirects from "pages/Redirect";

export default function useRoutes() {
  const { user } = useUserInfo();
  const isCompanyAccess = user?.userAccessType=="company";

  return [
    {
      path: "/login",
      component: Login,
      guard: {
        valid: !user?.email,
        redirect:isCompanyAccess ? "/agency/dashboard" :`/location/${user?.assignedLocations?.[0]}/dashboard`,
      },
    },
    // authentication
    { path: "/register", component: Register },
    { path: "/redirect/*", component: Redirects },
    {
      path: "/agency/*",
      component: Agency,
      guard: {
        valid: user?.email && isCompanyAccess,
        redirect:user && !isCompanyAccess ?`/location/${user?.assignedLocations?.[0]}/dashboard` : "/login",
      },
    },
    {
      path: "/location/:locationId/*",
      component: Location,
      guard: {
        valid: user?.email,
        redirect: "/login",
      },
    },
  ];
}
